export default [
  { value: 'brain', text: 'Brain' },
  { value: 'internal', text: 'Internal' },
  { value: 'lesion', text: 'Lesion' },
];
